module.exports = __webpack_public_path__ + "media/icons/cena-white-48px-45e1de26.png";